import type { CarouselInternalState } from "react-multi-carousel";
import { XcoreTheme } from "design-system/xcore/theme";
import { useTheme, Button, ButtonProps } from "@xcorejs/ui";
import styled from "styled-components";

interface DotProps extends ButtonProps {
  active?: boolean;
  carouselState?: CarouselInternalState;
  index?: number;
}

const DotsStyle = styled(Button)<{ activeStyle?: boolean }>`
  background: ${({ activeStyle }) => (activeStyle ? "white" : "rgba(255,255,255,0.25)")};
  border: ${({ activeStyle }) => (activeStyle ? "1px solid currentColor" : "none")};
  box-shadow: none !important;
  transition: background 0.3s ease;

  &:focus {
    background: white;
    box-shadow: none !important;
  }
`;

const Dot = ({ active, carouselState: _, index: __, ...props }: DotProps) => {
  const theme = useTheme() as XcoreTheme;
  const dotProps = theme.carousel.dot;

  return (
    <div>
      <DotsStyle {...dotProps} {...props} activeStyle={active} />
    </div>
  );
};

export default Dot;
